import script from "./business.vue?vue&type=script&setup=true&lang=js"
export * from "./business.vue?vue&type=script&setup=true&lang=js"

import "./business.vue?vue&type=style&index=0&id=ffa253d0&lang=less&scoped=true"

import exportComponent from "C:\\Users\\11920\\Desktop\\vue_db\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ffa253d0"]])

export default __exports__